import {
  GROWTHBOOK_LOADED,
  OPTIMIZE_READY,
  SET_EXPERIMENT,
} from '../../constants/experiment';

export const setExperiment = (payload) => ({
  type: SET_EXPERIMENT,
  payload,
});

export const optimizeReady = () => ({ type: OPTIMIZE_READY });

export const setGrowthBookLoaded = () => ({
  type: GROWTHBOOK_LOADED,
});
